var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwittercomponent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#6695ce"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.56 34.67c10.74 0 16.62-8.9 16.62-16.62v-.76a11.9 11.9 0 002.92-3 11.89 11.89 0 01-3.36.92 5.87 5.87 0 002.57-3.24 11.32 11.32 0 01-3.71 1.42 5.84 5.84 0 00-10 5.33 16.57 16.57 0 01-12-6.1 5.85 5.85 0 001.81 7.8 5.7 5.7 0 01-2.64-.74v.08a5.85 5.85 0 004.68 5.73 5.71 5.71 0 01-1.54.2 5.77 5.77 0 01-1.1-.1 5.83 5.83 0 005.46 4.05 11.64 11.64 0 01-7.27 2.5 9.32 9.32 0 01-1.4-.08 16.5 16.5 0 009 2.63",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittercomponent);
export default ForwardRef;